import PropTypes from "prop-types";
import styles from "./styles";
import { useState } from "react";

export const CopyCodeButton = ({ value, title, successMessage }) => {
  const [codeCopied, setCodeCopied] = useState(false);

  return (
    <div className={styles.container}>
      <button
        className="app_leavesden2"
        onClick={async () => {
          await navigator.clipboard.writeText(value);
          setCodeCopied(true);
          setTimeout(() => setCodeCopied(false), 3000);
        }}
      >
        {title}
      </button>
      {codeCopied && (
        <div className={`${styles.popover} app_leavesden2`}>
          {successMessage}
        </div>
      )}
    </div>
  );
};

CopyCodeButton.propTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  successMessage: PropTypes.string,
};

CopyCodeButton.defaultProps = {
  value: "",
  title: "",
  successMessage: "",
};
